import employmentCheck from '@/views/employmentCheck/index.vue'
export const employmentCheckRouter = [
  {
    path: `/employmentCheck/index`,
    name: 'employmentCheck',
    component: employmentCheck,
  },
]
